export default __webpack_public_path__ + "img/4d1aa2eb809db2c6.d84545dd37e0f49b0809a12adbeeccd0.jpg";